export default __webpack_public_path__ + "static/media/prathibha.ef8a4859.jfif";